<div class="container-fluid main-container">
    <div class="w-full-hd card-container" *ngIf="model$ | async">
                        
            <div class="box-search">
                <app-employee-search></app-employee-search>
            </div>
            <div class="box-rp" *ngIf="selectedUserHasEmployee">
                <app-review-period componentTitleKey="EMPLOYEE.REVIEWS"></app-review-period>
            </div>
        
            <div class="box-contact">
                <app-contact-details></app-contact-details>
            </div>
            <div class="box-position" *ngIf="selectedUserHasEmployee">
               <app-employee-position></app-employee-position>
            </div>
            
            <div class="box-password">
                <app-change-password [userName]="userProfile.userName"></app-change-password>
            </div>
            <div class="box-language">
                <app-user-language></app-user-language>
            </div>            
            <div class="box-leader" *ngIf="selectedUserHasEmployee">
                <app-leader></app-leader>
            </div>
        
            <div class="box-roles" *ngIf="isLoggedInSA || isLoggedInAdmin">
                <app-user-roles></app-user-roles>
            </div>

            <div class="box-status" *ngIf="userProfile && (isLoggedInSA || isLoggedInAdmin || isLoggedInAssistant || isDeleteInProgress) && (!isSelf || isDeleteInProgress)">
                <app-card #card 
                    [cardTitle]="'EMPLOYEE.STATUS' | translate" 
                    [showEdit]="false">

                    <div slot="readonly">
                        <div *ngIf="!isEmployeeDeleted && !isDeleteInProgress">
                            <!-- Employee Status Dropdown -->
                            <div class="mb-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'EMPLOYEE.EMPLOYEE_STATUS' | translate }}</mat-label>
                                    <mat-select [value]="userProfile.employee.employeeStatus" (selectionChange)="onEmployeeStatusChange($event.value)">
                                        <mat-option [value]="employeeStatus.Active">{{ 'EMPLOYEE.ACTIVE' | translate }}</mat-option>
                                        <mat-option [value]="employeeStatus.Inactive">{{ 'EMPLOYEE.INACTIVE' | translate }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            
                            <!-- Existing Delete Button -->
                            <div>
                                <button mat-flat-button color="warn" class="hidden-print icon-button vertical-middle bg-success" (click)="markForDelete()" [title]="'EMPLOYEE.DELETE_USER' | translate">
                                    <mat-icon>delete</mat-icon> {{ 'EMPLOYEE.DELETE_USER' | translate }}
                                </button>
                            </div>
                        </div>

                        <div *ngIf="isDeleteInProgress">
                            <p>
                                {{ 'EMPLOYEE.ACCOUNT_MARKED_FOR_DELETION' | translate }}<br>
                                {{ 'EMPLOYEE.DELETION_DATE' | translate }} <strong>{{ userProfile?.employee?.employeeEvent?.deadline | datePlain}}</strong><br>
                                {{ 'EMPLOYEE.PRESERVE_PROFILE_MESSAGE' | translate }}
                            </p>

                            <button mat-flat-button color="primary" class="hidden-print icon-button vertical-middle bg-success" (click)="cancelDelete()" [title]="'EMPLOYEE.PRESERVE_ACCOUNT' | translate">
                                {{ 'EMPLOYEE.PRESERVE_ACCOUNT' | translate }}
                            </button>
                        </div>

                        <div *ngIf="isEmployeeDeleted">
                            {{ 'EMPLOYEE.EMPLOYEE_DELETED' | translate }}
                        </div>
                    </div>

                </app-card>
            </div>
    
    </div>

    
</div>
